import styled from 'styled-components';

export const Header = styled.header`
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 100;
  background: #000;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  overflow: visible;
`;

export const TopNav = styled.nav`
  /* width: min(100%, 1280px); */
  min-height: 86px;
  margin: 0 auto;
  padding: var(--space-m) var(--space-xxl);

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-xl);

  position: relative;

  &::after {
    content: '';

    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;

    width: 55%;

    background: radial-gradient(
        circle at 90% 50%,
        rgba(255, 210, 66, 0.16),
        transparent 34%
      ),
      linear-gradient(
        90deg,
        transparent 0%,
        rgba(242, 175, 23, 0.08) 58%,
        rgba(230, 139, 7, 0.12) 100%
      );

    pointer-events: none;

    z-index: 0;
  }

  .logoLink {
    display: inline-flex;
    align-items: center;

    flex-shrink: 0;

    position: relative;
    z-index: 2;
  }

  @media (max-width: 1000px) {
    padding: var(--space-m) var(--space-l);
  }

  @media (max-width: 600px) {
    min-height: 72px;
    padding: var(--space-s) var(--space-m);
  }
`;

export const LogoImg = styled.img`
  height: 58px;
  width: auto;

  display: block;

  position: relative;
  z-index: 3;

  @media (max-width: 900px) {
    height: 48px;
  }

  @media (max-width: 500px) {
    height: 42px;
  }
`;

export const DesktopLinks = styled.nav`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--space-xxs);

  position: relative;
  z-index: 2;

  a {
    position: relative;

    display: inline-flex;
    align-items: center;

    padding: var(--space-xs) var(--space-m);

    border-radius: 999px;

    color: rgba(255, 255, 255, 0.8);

    text-decoration: none;

    font-size: 0.95rem;
    font-weight: 700;
    line-height: 1;

    transition:
      color 0.2s ease,
      background-color 0.2s ease;

    &:hover {
      color: var(--yellow4);
      background: rgba(255, 255, 255, 0.06);
    }

    &.active {
      color: var(--yellow4);
      background: rgba(255, 255, 255, 0.08);
    }
  }

  .iconButton {
    width: 40px;
    height: 40px;

    display: inline-flex;
    align-items: center;
    justify-content: center;

    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 50%;

    background: rgba(255, 255, 255, 0.06);
    color: var(--yellow4);

    cursor: pointer;

    transition:
      background-color 0.2s ease,
      border-color 0.2s ease,
      transform 0.2s ease;

    svg {
      font-size: 1.1rem;
    }

    &:hover {
      background: rgba(255, 210, 107, 0.12);
      border-color: rgba(255, 210, 107, 0.28);
      transform: translateY(-1px);
    }
  }

  .dropdown {
    position: relative;
    display: flex;
    align-items: center;
  }

  .dropdownTrigger {
    appearance: none;
    border: 0;
    background: transparent;
    color: rgba(255, 255, 255, 0.8);
    font: inherit;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    padding: var(--space-xs) var(--space-m);
    /* border-radius: 999px; */
    font-size: 0.95rem;
    font-weight: 700;
    line-height: 1;
    text-decoration: none;
    transition:
      color 0.2s ease,
      background-color 0.2s ease;
    border-left: 1px solid rgba(255, 210, 66, 0.14);
    border-right: 1px solid rgba(255, 210, 66, 0.14);
    margin: 0 var(--space-s);
  }

  /* Training trigger variant - no left/right bars */
  .trainingTrigger {
    appearance: none;
    border: 0;
    background: transparent;
    /* color: rgba(255, 255, 255, 0.8); */
    font: inherit;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    padding: var(--space-xs) var(--space-m);
    font-size: 0.95rem;
    font-weight: 700;
    line-height: 1;
    text-decoration: none;
    transition:
      color 0.2s ease,
      background-color 0.2s ease;
  }

  .trainingTrigger:hover,
  .dropdown.open .trainingTrigger {
    color: var(--orange4);
    background: rgba(255, 255, 255, 0.06);
  }

  .dropdownTrigger:hover,
  .dropdown.open .dropdownTrigger {
    color: var(--orange4);
    background: rgba(255, 255, 255, 0.06);
  }

  .dropdownContent {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1000;

    width: min(320px, calc(100vw - 2rem));
    padding: 0.75rem;

    background: var(--white, #fff);
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 0.75rem;
    box-shadow: 0 18px 45px rgba(0, 0, 0, 0.14);

    opacity: 0;
    visibility: hidden;
    pointer-events: none;

    transform: translateY(6px);
    transition:
      opacity 160ms ease,
      transform 160ms ease,
      visibility 160ms ease;
  }

  .dropdown.open .dropdownContent {
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
    transform: translateY(0);
  }

  /* User dropdown variant anchored to the right to prevent overflow */
  .userDropdown {
    position: relative;
    display: inline-flex;
    align-items: center;
  }

  .userDropdownContent {
    position: absolute;
    top: 100%;
    right: 0;
    left: auto;
    z-index: 1000;

    width: min(240px, calc(100vw - 2rem));
    padding: 0.5rem;

    background: var(--white, #fff);
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 0.5rem;
    box-shadow: 0 18px 45px rgba(0, 0, 0, 0.14);

    opacity: 0;
    visibility: hidden;
    pointer-events: none;

    transform: translateY(6px);
    transition:
      opacity 160ms ease,
      transform 160ms ease,
      visibility 160ms ease;
  }

  .userDropdown.open .userDropdownContent {
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
    transform: translateY(0);
  }

  .userDropdownContent .dropdownItem {
    display: block;
    width: 100%;
    text-align: left;
    padding: 0.6rem 0.8rem;
    border-radius: 0.35rem;
    background: transparent;
    border: 0;
    color: inherit;
    cursor: pointer;
  }

  .userDropdownContent .dropdownItem:hover {
    background: rgba(0, 0, 0, 0.04);
  }

  .dropdownItem {
    display: block;
    padding: 0.9rem 1rem;
    border-radius: 0.55rem;
    color: inherit;
    text-decoration: none;
  }

  .dropdownItem:hover,
  .dropdownItem:focus-visible {
    background: rgba(0, 0, 0, 0.05);
  }

  .dropdownTitle {
    font-weight: 700;
    color: var(--orange5);
  }

  .dropdownSubtitle {
    margin-top: 0.2rem;
    font-size: 0.85rem;
    opacity: 0.7;
    color: var(--grey7);
  }

  button:not(.iconButton) {
    margin-left: var(--space-xs);
  }
  .dropdownTitle:hover {
    color: var(--yellow5);
  }

  @media (max-width: 900px) {
    display: none;
  }
`;

export const BurgerWrapper = styled.div`
  display: none;
  position: relative;

  z-index: 2;
  /* border: 2px solid red; */
  @media (max-width: 900px) {
    display: flex;
    gap: 1rem;
    .iconButton {
      width: 40px;
      height: 40px;

      display: inline-flex;
      align-items: center;
      justify-content: center;

      border: 1px solid rgba(255, 255, 255, 0.08);
      border-radius: 50%;

      background: rgba(255, 255, 255, 0.06);
      color: var(--yellow4);

      cursor: pointer;

      transition:
        background-color 0.2s ease,
        border-color 0.2s ease,
        transform 0.2s ease;

      svg {
        font-size: 1.1rem;
      }

      &:hover {
        background: rgba(255, 210, 107, 0.12);
        border-color: rgba(255, 210, 107, 0.28);
        transform: translateY(-1px);
      }
    }
    .dropdown {
      position: relative;
      display: flex;
      align-items: center;
    }

    .dropdownTrigger {
      appearance: none;
      border: 0;
      background: transparent;
      color: rgba(255, 255, 255, 0.8);
      font: inherit;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      padding: var(--space-xs) var(--space-m);
      /* border-radius: 999px; */
      font-size: 0.95rem;
      font-weight: 700;
      line-height: 1;
      text-decoration: none;
      transition:
        color 0.2s ease,
        background-color 0.2s ease;
      border-left: 1px solid rgba(255, 210, 66, 0.14);
      border-right: 1px solid rgba(255, 210, 66, 0.14);
      margin: 0 var(--space-s);
    }

    /* Training trigger variant - no left/right bars */
    .trainingTrigger {
      appearance: none;
      border: 0;
      background: transparent;
      /* color: rgba(255, 255, 255, 0.8); */
      font: inherit;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      padding: var(--space-xs) var(--space-m);
      font-size: 0.95rem;
      font-weight: 700;
      line-height: 1;
      text-decoration: none;
      transition:
        color 0.2s ease,
        background-color 0.2s ease;
    }

    .trainingTrigger:hover,
    .dropdown.open .trainingTrigger {
      color: var(--orange4);
      background: rgba(255, 255, 255, 0.06);
    }

    .dropdownTrigger:hover,
    .dropdown.open .dropdownTrigger {
      color: var(--orange4);
      background: rgba(255, 255, 255, 0.06);
    }

    .dropdownContent {
      position: absolute;
      top: 100%;
      left: 0;
      z-index: 1000;

      width: min(320px, calc(100vw - 2rem));
      padding: 0.75rem;

      background: var(--white, #fff);
      border: 1px solid rgba(0, 0, 0, 0.08);
      border-radius: 0.75rem;
      box-shadow: 0 18px 45px rgba(0, 0, 0, 0.14);

      opacity: 0;
      visibility: hidden;
      pointer-events: none;

      transform: translateY(6px);
      transition:
        opacity 160ms ease,
        transform 160ms ease,
        visibility 160ms ease;
    }

    .dropdown.open .dropdownContent {
      opacity: 1;
      visibility: visible;
      pointer-events: auto;
      transform: translateY(0);
    }

    /* User dropdown variant anchored to the right to prevent overflow */
    .userDropdown {
      position: relative;
      display: inline-flex;
      align-items: center;
    }

    .userDropdownContent {
      position: absolute;
      top: 100%;
      right: 0;
      left: auto;
      z-index: 1000;

      width: min(240px, calc(100vw - 2rem));
      padding: 0.5rem;

      background: var(--white, #fff);
      border: 1px solid rgba(0, 0, 0, 0.08);
      border-radius: 0.5rem;
      box-shadow: 0 18px 45px rgba(0, 0, 0, 0.14);

      opacity: 0;
      visibility: hidden;
      pointer-events: none;

      transform: translateY(6px);
      transition:
        opacity 160ms ease,
        transform 160ms ease,
        visibility 160ms ease;
    }

    .userDropdown.open .userDropdownContent {
      opacity: 1;
      visibility: visible;
      pointer-events: auto;
      transform: translateY(0);
    }

    .userDropdownContent .dropdownItem {
      display: block;
      width: 100%;
      text-align: left;
      padding: 0.6rem 0.8rem;
      border-radius: 0.35rem;
      background: transparent;
      border: 0;
      color: inherit;
      cursor: pointer;
    }

    .userDropdownContent .dropdownItem:hover {
      background: rgba(0, 0, 0, 0.04);
    }

    .dropdownItem {
      display: block;
      padding: 0.9rem 1rem;
      border-radius: 0.55rem;
      color: inherit;
      text-decoration: none;
    }

    .dropdownItem:hover,
    .dropdownItem:focus-visible {
      background: rgba(0, 0, 0, 0.05);
    }

    .dropdownTitle {
      font-weight: 700;
      color: var(--orange5);
    }

    .dropdownSubtitle {
      margin-top: 0.2rem;
      font-size: 0.85rem;
      opacity: 0.7;
      color: var(--grey7);
    }

    button:not(.iconButton) {
      margin-left: var(--space-xs);
    }
    .dropdownTitle:hover {
      color: var(--yellow5);
    }

    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
